import React, { useRef, useState, useCallback } from 'react'
import CardOperationsDetails from './operationDetails';
import List from 'src/components/grid.component';
import { CardIdHandler, OperationTimeHandler, OperationTypeHandler, StateHandler } from './service';
const CardOperationsGrid = ((props) => {
  const gridRef = useRef(null);
  const [detailsModal, setDetailsModal] = useState(false)
  const [selectedOperation, setSelectedOperation] = useState({})
  const [copiedId, setCopiedId] = useState('');
  const handledetails = useCallback((flag, data) => () => {
    setDetailsModal(flag)
    setSelectedOperation(data)
  }, [])
  const handleIdCopy = useCallback((id) => () => {
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId('');
    }, 300)
  }, [])
  const cardIdHandler = useCallback((props) => {
    return <CardIdHandler handleCopy={handleIdCopy} copiedId={copiedId} data={props?.dataItem} handledetails={handledetails} />
  }, [copiedId, handleIdCopy, handledetails])
  const operationTypeHandler = useCallback((props) => {
    return <OperationTypeHandler data={props?.dataItem} />
  }, [])
  const operationTimeHandler = useCallback((props) => {
    return <OperationTimeHandler data={props?.dataItem} />
  }, [])
  const stateHandler = useCallback((props) => {
    return <StateHandler data={props?.dataItem} />
  }, [])
  const customcells = {
    "cardId": cardIdHandler,
    "operationType": operationTypeHandler,
    "operationTime": operationTimeHandler,
    "state": stateHandler,
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells]);
  return (
    <div>
      <List
        url={process.env.REACT_APP_GRID_API + `api/CardsManageService/cardsoperations`}
        pSize={10}
        additionalParams={props?.filterValues}
        className="custom-grid"
        ref={gridRef}
        showExcelExport={props?.isExcelExport}
        pKey={"Card Activity"}
        screenName={'Card_Activity'}
        renderCustomCell={renderCustomCell}
        refresh={props?.isRefresh}
        refreshCallBack={props?.refreshCallBack}
      />
      <CardOperationsDetails isModal={detailsModal} closeModal={handledetails} data={selectedOperation} />
    </div>
  )
})
export default CardOperationsGrid